import { BaseModel, ID } from '@models/base'
import { UserModel } from '@models/user'

import { PatientModel } from './patient'
import { TaskAttachmentModel } from './taskAttachment'
import { TaskCommentModel } from './taskComment'
import { ClinicModel } from './clinic'

enum TaskAssignModeEnum {
  AssignedToMe = 'ASSIGNED_TO_ME',
  AssignedByMe = 'ASSIGNED_BY_ME',
}

enum TaskStatusEnum {
  Todo = 'TODO',
  Processing = 'PROCESSING',
  Done = 'DONE',
}

enum TaskPriorityEnum {
  Low = 'LOW',
  Medium = 'MEDIUM',
  High = 'HIGH',
  Extreme = 'EXTREME',
}

export type FileUploadModel = {
  id?: string
  file?: File
}

type TaskModel = BaseModel<{
  assigned_user: UserModel | null
  assigned_user_id: ID
  assigner_user: UserModel | null
  assigner_user_id: ID | null
  clinic: ClinicModel | null
  clinic_id: ID
  descriptions: string
  due_date: string
  name: string
  patient: PatientModel | null
  patient_id: ID
  priority: TaskPriorityEnum
  status: TaskStatusEnum
  task_attachments: Array<TaskAttachmentModel>
  task_comments: Array<TaskCommentModel>
  total_comments: number
}>

export { TaskAssignModeEnum, TaskStatusEnum, TaskPriorityEnum }
export type { TaskModel }
